export default "/kiban/_next/static/images/entrust-4d75ad2c8fee7a8b23a607b059981fa5.png";